/**
 * ArticleCta — call-to-action section at the bottom of a blog article
 */
import { useTranslation } from "react-i18next";

interface ArticleCtaProps {
  locale: string;
}

export function ArticleCta({ locale }: Readonly<ArticleCtaProps>) {
  const { t } = useTranslation();

  return (
    <aside className="mx-auto mt-16 flex max-w-[42rem] flex-col items-start gap-6 rounded-2xl bg-background-7 p-8 sm:flex-row sm:items-center sm:justify-between max-mobile:p-6">
      <h2 className="text-medium font-bold text-balance text-text-1">
        {t("Blog.ctaTitle")}
      </h2>
      <a
        href={`/${locale}/collections/personalizirane-anatomske-papuce`}
        className="shrink-0 rounded-lg bg-primary px-5 py-3 text-small font-semibold text-white transition-[background-color,scale] duration-150 ease-out hover:bg-primary-darker1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 active:scale-[0.96]"
      >
        {t("Blog.shopAnatomic")}
      </a>
    </aside>
  );
}
